module.exports = __webpack_public_path__ + "static/img/judges_chenfang.fd2b16a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhengwen_2018/judges_chenfang.png
// module id = La1M
// module chunks = 0